"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderEmptyActionButton = exports.renderActionButton = exports.FullActionButton = exports.IconActionButton = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
const Spinner_1 = require("../../../Spinner/Spinner");
const Tooltip_1 = require("../../../Tooltip");
require("./actionButton.scss");
const className = 'column-action';
const iconClassName = `${className}__icon`;
const IconActionButton = (props) => {
    const { click, iconName, iconModifiers, isLoading, disabled, text, additionClassNames, hidden, } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement(Tooltip_1.Tooltip, { text: text, modificators: ['white', 'left-aligned'] },
        react_1.default.createElement("span", { className: (0, classFunctions_1.getClassNames)(className, [
                disabled ? 'disabled' : undefined,
            ], additionClassNames) },
            react_1.default.createElement("span", { className: (0, classFunctions_1.getClassNames)(iconClassName, iconModifiers), onClick: () => {
                    if (isLoading || disabled)
                        return;
                    click();
                } }, isLoading ? react_1.default.createElement(Spinner_1.Spinner, null) : react_1.default.createElement(Icon_1.Icon, { name: iconName })))));
};
exports.IconActionButton = IconActionButton;
const FullActionButton = (props) => {
    const { click, iconName, iconModifiers = [], isLoading, disabled, text, } = props;
    return (react_1.default.createElement("span", { onClick: () => {
            if (isLoading || disabled)
                return;
            click();
        }, className: (0, classFunctions_1.getClassNames)(className, [
            'full',
            disabled ? 'disabled' : undefined,
        ]), role: 'button' },
        react_1.default.createElement("span", { className: (0, classFunctions_1.getClassNames)(iconClassName, iconModifiers) }, isLoading ? react_1.default.createElement(Spinner_1.Spinner, null) : react_1.default.createElement(Icon_1.Icon, { name: iconName })),
        react_1.default.createElement("span", { className: `${className}__text` }, text)));
};
exports.FullActionButton = FullActionButton;
const renderActionButton = (props) => {
    const { kind, ...restProps } = props;
    if (kind === 'icon')
        return react_1.default.createElement(exports.IconActionButton, { ...restProps });
    return react_1.default.createElement(exports.FullActionButton, { ...restProps });
};
exports.renderActionButton = renderActionButton;
const renderEmptyActionButton = (kind) => (react_1.default.createElement("div", { className: kind === 'icon' ? `${className}__empty-icon` : undefined }));
exports.renderEmptyActionButton = renderEmptyActionButton;
//# sourceMappingURL=actionButton.js.map